import { Provider } from 'react-redux';
import Root from './config/index';
import { dataStore } from './Store';
import 'react-toastify/dist/ReactToastify.css';
import 'sweetalert2/dist/sweetalert2.min.css';

export default function App() {
	return (
		<Provider store={dataStore}>
			<Root />
		</Provider>
	);
}
